module.exports = __webpack_public_path__ + "media/images/icon/navigation/market-active-965ba69e0870663e99dd240d24177e8f.svg";